import React from 'react';

import { useTranslation } from 'react-i18next';

import {
  EventStatus,
  SubmissionStatus,
} from 'lane-shared/domains/visitorManagement/types';
import { useFlag } from 'lane-shared/hooks';
import { FeatureFlag } from 'constants-flags';

import Pill from 'components/general/Pill';

import { StatusListItems } from '../../types/EventStatus';

import styles from './VisitorManagementStatusChip.scss';

export function VisitorManagementStatusChip({
  status,
  pillClassname = '',
}: {
  status: SubmissionStatus | undefined;
  pillClassname?: string;
}) {
  const { t } = useTranslation();
  const visitorManagementFlag = useFlag(FeatureFlag.VisitorManagement, false);

  if (!visitorManagementFlag) return null;

  if (!status || status !== SubmissionStatus.Cancelled) return null;

  const cancelledStatus = StatusListItems.find(
    st => st.value === EventStatus.EVENT_STATUS_CANCELLED
  ) || { label: 'web.admin.channel.visitor.log.status.cancelled' };

  return (
    <div className={pillClassname}>
      <Pill
        text={t(cancelledStatus.label)}
        color="red"
        size="medium"
        className={styles.cancelled}
      />
    </div>
  );
}
